import { Ping } from '../response/index.js';
import { Command } from './Command.js';
export class PingCommand extends Command {
    respond() {
        this.invokeCallback(new Ping());
    }
}
